import script from "./AlertsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsTable.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/table.css?vue&type=style&index=0&id=796e51dc&scoped=true&lang=css&external"
import "./AlertsTable.vue?vue&type=style&index=1&id=796e51dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796e51dc"]])

export default __exports__